import type {Dispatch, ThunkAction} from 'src/reducers';
import type {
  GenericError,
  ReferralLeaderBoard,
  ReferralAgentToConnect,
  ReferralAgent,
  ReferralAgencyStatsInfo,
  ReferralUserStatsInfo,
} from 'src/types/referral-v2';
import {thunkify as flow} from 'src/utils/thunks';
import {key, fetching} from 'src/utils/redux';
import * as reduxApi from 'src/utils/redux-api';

import {DEFAULT_ERROR} from 'src/action-creators/referral-v2/referral-jobs';


export const REFERRAL_LEADERBOARD_LOADING =
  'referral/referral-leaderboard-loading';
export const REFERRAL_LEADERBOARD = 'referral/referral-leaderboard';
export const REFERRAL_LEADERBOARD_ERROR = 'referral/referral-leaderboard-error';

export const REFERRAL_AGENT_LOADING = 'referral/referral-agent-loading';
export const REFERRAL_AGENT = 'referral/referral-agent';
export const REFERRAL_AGENT_ERROR = 'referral/referral-agent-error';

export const REFERRAL_AGENCY_STATS_LOADING =
  'referral/referral-agency-stats-loading';
export const REFERRAL_AGENCY_STATS = 'referral/referral-agency-stats';
export const REFERRAL_AGENCY_STATS_ERROR =
  'referral/referral-agency-stats-error';

export const REFERRAL_USER_STATS_LOADING =
  'referral/referral-user-stats-loading';
export const REFERRAL_USER_STATS = 'referral/referral-user-stats';
export const REFERRAL_USER_STATS_ERROR = 'referral/referral-user-stats-error';

type ReferralLeaderboardLoadingAction = {
  type: typeof REFERRAL_LEADERBOARD_LOADING;
};

type ReferralLeaderboardAction = {
  type: typeof REFERRAL_LEADERBOARD;
  payload: ReferralLeaderBoard[];
};

type ReferralLeaderboardErrorAction = {
  type: typeof REFERRAL_LEADERBOARD_ERROR;
  payload: GenericError | null | undefined;
};

type ReferralAgentLoadingAction = {
  type: typeof REFERRAL_AGENT_LOADING;
};

type ReferralAgentAction = {
  type: typeof REFERRAL_AGENT;
  payload: ReferralAgent | null | undefined;
};

type ReferralAgentErrorAction = {
  type: typeof REFERRAL_AGENT_ERROR;
  payload: GenericError | null | undefined;
};

type ReferralAgencyStatsLoadingAction = {
  type: typeof REFERRAL_AGENCY_STATS_LOADING;
};

type ReferralAgencyStatsAction = {
  type: typeof REFERRAL_AGENCY_STATS;
  payload: ReferralAgencyStatsInfo | null | undefined;
};

type ReferralAgencyStatsErrorAction = {
  type: typeof REFERRAL_AGENCY_STATS_ERROR;
  payload: GenericError | null | undefined;
};

type ReferralUserStatsLoadingAction = {
  type: typeof REFERRAL_USER_STATS_LOADING;
};

type ReferralUserStatsAction = {
  type: typeof REFERRAL_USER_STATS;
  payload: ReferralUserStatsInfo | null | undefined;
};

type ReferralUserStatsErrorAction = {
  type: typeof REFERRAL_USER_STATS_ERROR;
  payload: GenericError | null | undefined;
};

export type ReferralDashboardActions =
  | ReferralLeaderboardLoadingAction
  | ReferralLeaderboardAction
  | ReferralLeaderboardErrorAction
  | ReferralAgentLoadingAction
  | ReferralAgentAction
  | ReferralAgentErrorAction
  | ReferralAgencyStatsLoadingAction
  | ReferralAgencyStatsAction
  | ReferralAgencyStatsErrorAction
  | ReferralUserStatsLoadingAction
  | ReferralUserStatsAction
  | ReferralUserStatsErrorAction;

export const getReferralLeaderboard = (
  payload: ReferralLeaderBoard[],
): ReferralLeaderboardAction => ({
  type: REFERRAL_LEADERBOARD,
  payload,
});

export const getReferralLeaderboardLoading =
  (): ReferralLeaderboardLoadingAction => ({
    type: REFERRAL_LEADERBOARD_LOADING,
  });

export const getReferralLeaderboardError = (
  payload?: GenericError | null,
): ReferralLeaderboardErrorAction => ({
  type: REFERRAL_LEADERBOARD_ERROR,
  payload,
});

export const getReferralAgents = (
  payload: ReferralAgent,
): ReferralAgentAction => ({
  type: REFERRAL_AGENT,
  payload,
});

export const getReferralAgentsLoading = (): ReferralAgentLoadingAction => ({
  type: REFERRAL_AGENT_LOADING,
});

export const getReferralAgentsError = (
  payload?: GenericError | null,
): ReferralAgentErrorAction => ({
  type: REFERRAL_AGENT_ERROR,
  payload,
});

export const getReferralAgencyStats = (
  payload: ReferralAgencyStatsInfo,
): ReferralAgencyStatsAction => ({
  type: REFERRAL_AGENCY_STATS,
  payload,
});

export const getReferralAgencyStatsLoading =
  (): ReferralAgencyStatsLoadingAction => ({
    type: REFERRAL_AGENCY_STATS_LOADING,
  });

export const getReferralAgencyStatsError = (
  payload?: GenericError | null,
): ReferralAgencyStatsErrorAction => ({
  type: REFERRAL_AGENCY_STATS_ERROR,
  payload,
});

export const getReferralUserStats = (
  payload: ReferralUserStatsInfo,
): ReferralUserStatsAction => ({
  type: REFERRAL_USER_STATS,
  payload,
});

export const getReferralUserStatsLoading =
  (): ReferralUserStatsLoadingAction => ({
    type: REFERRAL_USER_STATS_LOADING,
  });

export const getReferralUserStatsError = (
  payload?: GenericError | null,
): ReferralUserStatsErrorAction => ({
  type: REFERRAL_USER_STATS_ERROR,
  payload,
});

export const fetchReferralLeaderBoard: (query: {
  start_date: string;
  end_date: string;
}) => ThunkAction<void> = flow(
  key(() => 'referral/stats/leaderboard'),
  fetching(),
)((query) => (dispatch: Dispatch) => {
  dispatch(getReferralLeaderboardLoading());

  return dispatch(
    reduxApi.get(
      `referral/stats/leaderboard?start_date=${query.start_date}&end_date=${query.end_date}`,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: ReferralAgentToConnect[]) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
    (response: ReferralAgentToConnect[]) => {
      // @ts-expect-error - TS2345 - Argument of type 'ReferralAgentToConnect[]' is not assignable to parameter of type 'ReferralLeaderBoard[]'.
      dispatch(getReferralLeaderboard(response));
    },
    (error) => {
      dispatch(
        getReferralLeaderboardError(error?.response?.errors || DEFAULT_ERROR),
      );
    },
  );
});

export const fetchReferralAgents: (query: {
  start_date: string;
  end_date: string;
}) => ThunkAction<void> = flow(
  key(() => 'referral/stats/agent'),
  fetching(),
)((query: {start_date: string; end_date: string}) => (dispatch: Dispatch) => {
  dispatch(getReferralAgentsLoading());

  return dispatch(
    reduxApi.get(
      `referral/stats/agent?start_date=${query.start_date}&end_date=${query.end_date}`,
    ),
  ).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: ReferralAgent) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
    (response: ReferralAgent) => {
      dispatch(getReferralAgents(response));
    },
    (error) => {
      dispatch(
        getReferralAgentsError(error?.response?.errors || DEFAULT_ERROR),
      );
    },
  );
});

export const fetchReferralAgencyStats: (query: {
  start_date: string;
  end_date: string;
}) => ThunkAction<void> = flow(
  key(() => 'referral/stats/agency'),
  fetching(),
)((query: {start_date: string; end_date: string}) => (dispatch: Dispatch) => {
  dispatch(getReferralAgencyStatsLoading());

  return (
    dispatch(
      reduxApi.get(
        `referral/stats/agency?start_date=${query.start_date}&end_date=${query.end_date}`,
      ),
    )
      // @ts-expect-error - TS2345 - Argument of type '(response: ReferralAgencyStatsInfo) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
      .then((response: ReferralAgencyStatsInfo) => {
        dispatch(getReferralAgencyStats(response));
      })
      .catch((error) => {
        dispatch(
          getReferralAgencyStatsError(error?.response?.errors || DEFAULT_ERROR),
        );
      })
  );
});

export const fetchReferralUserStats: (query: {
  start_date: string;
  end_date: string;
}) => ThunkAction<void> = flow(
  key(() => 'referral/stats/impact'),
  fetching(),
)((query: {start_date: string; end_date: string}) => (dispatch: Dispatch) => {
  dispatch(getReferralUserStatsLoading());

  return (
    dispatch(
      reduxApi.get(
        `referral/stats/impact?start_date=${query.start_date}&end_date=${query.end_date}`,
      ),
    )
      // @ts-expect-error - TS2345 - Argument of type '(response: ReferralUserStatsInfo) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
      .then((response: ReferralUserStatsInfo) => {
        dispatch(getReferralUserStats(response));
      })
      .catch((error) => {
        dispatch(
          getReferralUserStatsError(error?.response?.errors || DEFAULT_ERROR),
        );
      })
  );
});
